import { atomFamily } from "recoil";

import { ViewDto } from "../../dto";
import { RydeUiUnit, TFinalSchemaInitState } from "../../models";

export const viewDtosAtomFamily = atomFamily<ViewDto[] | undefined, RydeUiUnit>(
  {
    key: "viewDtosAtomFamily",
    default: undefined,
  },
);

export const activeViewIdAtomFamily = atomFamily<
  number | undefined,
  RydeUiUnit
>({
  key: "activeViewIdAtomFamily",
  default: undefined,
});

export const finalSchemaInitStateAF = atomFamily<
  TFinalSchemaInitState,
  RydeUiUnit
>({
  key: "finalSchemaInitStateAF",
  default: {
    isViewSet: false,
    isRootSchemaSet: false,
    isProfileScopeSet: false,
    isFinalSchemaSet: false,
    isActiveViewResolved: false,
  },
});
